import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles(theme => ({
  dialogTitle: {
    backgroundColor: theme.palette.primary.main,
  },
  representative: {
    marginRight: "128px",
  },
  activeRepresentative: {
    marginRight: "128px",
    backgroundColor: theme.palette.primary.main,
    color: "#ffffff",
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
      color: "#ffffff",
    },
  },
}))

export default styles
